import { render, staticRenderFns } from "./SkoleStandardPage.vue?vue&type=template&id=07647461"
import script from "./SkoleStandardPage.vue?vue&type=script&lang=js"
export * from "./SkoleStandardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports